import {createSlice} from '@reduxjs/toolkit'

export const creativesSlice = createSlice({
    name: 'creativesState',
    initialState: {
        isTemplateQuickPublishPopupOpen: false,
        isPlaylistQuickPublishPopupOpen: false,
    },
    reducers: {
        updateCreativesState: (state, action) => {
            if ('isTemplateQuickPublishPopupOpen' in action.payload) state.isTemplateQuickPublishPopupOpen = action.payload.isTemplateQuickPublishPopupOpen;
            if ('isPlaylistQuickPublishPopupOpen' in action.payload) state.isPlaylistQuickPublishPopupOpen = action.payload.isPlaylistQuickPublishPopupOpen;
        },
    }
})

export const { updateCreativesState, } = creativesSlice.actions
export default creativesSlice.reducer

// Selectors
export const selectIsTemplateQuickPublishPopupOpen = (state) => state.creativesState.isTemplateQuickPublishPopupOpen
export const selectIsPlaylistQuickPublishPopupOpen = (state) => state.creativesState.isPlaylistQuickPublishPopupOpen
